function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-19058{fill:#fff}\r\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "sool-Path_22212",
  d: "M62.357 164.188c-8.94-.051-16.335-18.3-16.335-27.6 0-15.182 11.389-18.506 15.778-18.506a18.155 18.155 0 0 1 5.953 1.464 13.306 13.306 0 0 0 3.4.974 10.579 10.579 0 0 0 2.439-.79 19.545 19.545 0 0 1 7.35-1.777h.017c2.153 0 8.682.473 12.608 6.367l.919 1.382-1.323 1c-1.89 1.426-5.34 4.028-5.34 9.182 0 6.1 3.906 8.452 5.783 9.581.828.5 1.686 1.012 1.686 2.136 0 .734-5.857 16.491-14.362 16.491a11.55 11.55 0 0 1-4.85-1.177 9.834 9.834 0 0 0-4.317-1.04 11.1 11.1 0 0 0-3.418.925 16.743 16.743 0 0 1-5.929 1.383z",
  className: "cls-19058",
  "data-name": "Path 22212",
  transform: "translate(-46.022 -104.119)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "sool-Path_22213",
  d: "M266.439 0c.221 7.987-5.49 13.528-11.2 13.18C254.3 6.806 260.949 0 266.439 0z",
  className: "cls-19058",
  "data-name": "Path 22213",
  transform: "translate(-230.619)"
});

var SvgApplestoreWhite = function SvgApplestoreWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sool-company",
    width: 49.27,
    height: 60.069,
    viewBox: "0 0 49.27 60.069",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApplestoreWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/applestore-white.e784b1a2.svg";
export { ForwardRef as ReactComponent };